import classes from "./ErrorMessage.module.css";

import { useTranslation } from "react-i18next";

export default function ErrorMessage({ children, classList }) {
  const { t } = useTranslation("general");

  return <p className={`${classes.errorMessage} ${classList}`}>{children}</p>;
}
